import './OrderGetStarted.scss';

import { Link, useSearchParams } from 'react-router';

import { ROUTES } from '@constants/routes';

import { useOrderContext } from './hooks/useOrderContext';

export function OrderGetStarted() {
  const [searchParams] = useSearchParams();
  const { partner } = useOrderContext();

  const promoCode = searchParams.get('promo_code');
  const baseUrl = partner
    ? `/${ROUTES.PARTNERSHIP}/${partner}/${ROUTES.ORDER_CHECK}`
    : `${ROUTES.ORDER}/${ROUTES.ORDER_CHECK}`;
  const checkEligibilityUrl = promoCode ? `${baseUrl}?promo_code=${promoCode}` : baseUrl;
  return (
    <>
      <div className='partner-get-started-page'>
        <div className='partner-get-started-card'>
          <h1>Start your genetic testing order</h1>
          <p>Welcome! Before we begin, we need a few details to confirm your access. Here is what to expect:</p>
          <ul>
            <li>You will provide basic demographic information such as your full name, date of birth, and email.</li>
            <li>Once verified, you will be taken directly into the ordering flow.</li>
            <li>If we are unable to verify your access, we will guide you to the next steps.</li>
          </ul>
          <Link to={checkEligibilityUrl} className='primary button' data-testid='orderStartBtn'>
            Get Started
          </Link>
        </div>
      </div>
    </>
  );
}
